import {
    CLOSE_SNACKBAR,
    OPEN_SNACKBAR,
} from '../actions/types/snackbar-action-types';
import { combineReducers } from 'redux';

function type( state = null, action ){
    let newState;

    switch( action.type ){
        case OPEN_SNACKBAR:
            newState = action.snackbarType;
            break;
        case CLOSE_SNACKBAR:
            newState = null;
            break;
        default:
            newState = state;
    }
    return newState;
}

function additionalOptions( state = null, action ){
    let newState;
    switch( action.type ){
        case OPEN_SNACKBAR:
            newState = action.additionalOptions || null;
            break;
        case CLOSE_SNACKBAR:
            newState = null;
            break;
        default:
            newState = state;
    }
    return newState;
}

export default combineReducers( {
    additionalOptions,
    type,
} );
